<template>
  <div class="calssTicket-tab">
    <PageTitle
      title=""
      :btn="$t('member.tab.classTicket.addClassTicket')"
      :btn2="$t('member.tab.classTicket.export')"
      btnFeature="admin.classTicketRecord.create"
      btn2Feature="admin.classTicketRecord.createSheetExportTask"
      @btnClick="classTicketDialog = true"
      @btn2Click="dialog.export = true"
    />
    <FiltersContainer>
      <BaseElInput
        v-model="search.code"
        clearable
        :placeholder="$t('member.tab.classTicket.searchCodePlaceholder')"
        @keypress.enter.native="refresh(true)"
        @clear="refresh(true)"
      >
        <i slot="prefix" class="el-input__icon el-icon-search" @click="refresh(true)" />
      </BaseElInput>
    </FiltersContainer>

    <BaseTable
      v-loading="loading"
      :data="classTicketRecordList"
      :empty-text="$t('member.tab.classTicket.emptyText')"
      :row-style="{ cursor: 'pointer' }"
    >
      <EmptyBlock slot="empty" />
      <BaseElTableColumn prop="code" :label="$t('member.tab.classTicket.code')" width="115" align="center" fixed="left" />
      <BaseElTableColumn prop="name" :label="$t('member.tab.classTicket.name2')" width="115" align="center" fixed="left">
        <template slot-scope="scope">
          <LinkItem :to="{ name: 'ClassTicketSetting', query: { name: scope.row.name } }">
            {{
              scope.row.name
            }}
          </LinkItem>
        </template>
      </BaseElTableColumn>
      <BaseElTableColumn prop="status" :label="$t('member.tab.classTicket.status')" align="center">
        <template slot-scope="scope">
          <Tag :type="classTicketTagType(scope.row.status)">
            {{ classTicketStatusLabel(scope.row) }}
          </Tag>
        </template>
      </BaseElTableColumn>
      <BaseElTableColumn prop="availableUseTimes" :label="$t('member.tab.classTicket.remainingQty')" align="center" />
      <BaseElTableColumn prop="availableTimes" :label="$t('member.tab.classTicket.totalQty')" align="center" />
      <BaseElTableColumn prop="origin" :label="$t('member.tab.classTicket.origin')" width="120" align="center">
        <template slot-scope="scope">
          {{ mapOrigin(scope.row.origin) }}
        </template>
      </BaseElTableColumn>
      <BaseElTableColumn v-if="false" prop="Branch" :label="$t('member.tab.classTicket.store')" align="center">
        <template slot-scope="scope">
          {{ scope.row.Branch?.name || '-' }}
        </template>
      </BaseElTableColumn>
      <BaseElTableColumn prop="price" :label="$t('member.tab.classTicket.price')" align="center" />
      <BaseElTableColumn prop="exp" :label="$t('member.tab.classTicket.expiryDate')" width="120" align="center">
        <template slot-scope="scope">
          {{ dateFormat(scope.row.exp) }}
        </template>
      </BaseElTableColumn>
      <BaseElTableColumn prop="note" :label="$t('member.tab.classTicket.note')" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.note || '-' }}
        </template>
      </BaseElTableColumn>
      <BaseElTableColumn v-if="isClassTicketBenefitSharingEnabled" prop="Shop" :label="$t('member.tab.classTicket.issuingBranch')" align="center">
        <template slot-scope="scope">
          {{ scope.row.Shop?.name || '-' }}
        </template>
      </BaseElTableColumn>
      <BaseElTableColumn v-if="isClassTicketBenefitSharingEnabled" prop="GrantedShop" :label="$t('member.tab.classTicket.grantBranch')" align="center">
        <template slot-scope="scope">
          {{ scope.row.GrantedShop?.name || '-' }}
        </template>
      </BaseElTableColumn>
      <BaseElTableColumn prop="createdAt" :label="$t('member.tab.classTicket.createdAt')" width="120" align="center">
        <template slot-scope="scope">
          {{ dateFormat(scope.row.createdAt) }}
        </template>
      </BaseElTableColumn>
      <BaseElTableColumn :label="$t('member.tab.classTicket.action')" fixed="right" align="center" width="120">
        <template slot-scope="scope">
          <TableEditBtnGroup
            hideDelete
            :hideCopy="false"
            :hideEdit="!useEditClassTicketRecord"
            :copyBtn="$t('member.tab.classTicket.detail')"
            @copy="findClassTicket(scope.row)"
            @edit=";(selectRow = scope.row), (classTicketRecordDialog = true)"
          />
        </template>
      </BaseElTableColumn>
    </BaseTable>

    <Pagination
      :curPage.sync="classTicketRecordTableOptions.page"
      :pageLimit="classTicketRecordTableOptions.pageLimit"
      :total="classTicketRecordCount"
      @pageChange="refresh(false)"
    />

    <!-- 新增堂票 -->
    <el-dialog
      :title="$t('member.tab.classTicket.addTitle')"
      :visible.sync="classTicketDialog"
      :close-on-click-modal="false"
      @close="resetClassTicketForm"
    >
      <BaseElForm
        ref="classTicketForm"
        :model="classTicketForm"
        :rules="classTicketFormRules"
        label-position="top"
        label-width="100px"
      >
        <BaseElFormItem :label="$t('member.tab.classTicket.classTicketLabel')" prop="classTicket">
          <BaseElSelect
            v-model="classTicketForm.classTicket"
            :placeholder="$t('member.tab.classTicket.selectClassTicket')"
            popper-class="select-popper"
            @visible-change="openClassTicketAdvanceSelect"
          >
            <BaseElSelectOption
              v-for="item in selectedClassTicket"
              :key="item.id"
              :label="classTicketOptionLabel(item)"
              :value="item.id"
            />
          </BaseElSelect>
        </BaseElFormItem>
        <BaseElFormItem :label="$t('member.tab.classTicket.quantityLabel')" prop="quantity">
          <BaseElInput v-model="classTicketForm.quantity" :placeholder="$t('member.tab.classTicket.enterQuantity')" />
        </BaseElFormItem>
        <BaseElFormItem :label="$t('member.tab.classTicket.unitPrice')" prop="price">
          <BaseElInput v-model="classTicketForm.price" type="number" :placeholder="$t('member.tab.classTicket.enterUnitPrice')" />
        </BaseElFormItem>
        <BaseElFormItem :label="$t('member.tab.classTicket.note')" prop="note">
          <BaseElInput v-model="classTicketForm.note" :placeholder="$t('member.tab.classTicket.enterPlaceholder')" />
        </BaseElFormItem>
      </BaseElForm>
      <div slot="footer">
        <BaseElButton plain @click="classTicketDialog = false">{{ $t('member.tab.classTicket.back') }}</BaseElButton>
        <BaseElButton type="primary" @click="deBounce">{{ $t('member.tab.classTicket.confirm') }}</BaseElButton>
      </div>
    </el-dialog>

    <!-- 堂票使用紀錄 -->
    <EditMemberClassTicketRecordModal
      v-if="classTicketRecordDialog"
      :record="selectRow"
      @close="classTicketRecordDialog = false"
      @refresh="refresh"
    />

    <ClassTicketRecordDetail
      :show="showDrawer"
      :selectClassTicket="selectRow"
      :classTicketRecordSerials="classTicketRecordSerials"
      :useEditClassTicketRecordCancel="useEditClassTicketRecordCancel"
      @close="closeDrawer"
      @cancel="deleteDialog = true"
      @refresh="refresh"
    />
    <DeleteDialog
      v-if="deleteDialog"
      :title="$t('member.tab.classTicket.voidTitle')"
      :content="$t('member.tab.classTicket.voidConfirmContent')"
      width="40%"
      :btnString="$t('member.tab.classTicket.voidBtn')"
      @close="deleteDialog = false"
      @delete="cancelClassTicketRecord"
    />

    <ExportOptionsDialog
      v-if="dialog.export"
      @close="dialog.export = false"
      @export="prepareExport"
    />
    <ExportDialog
      v-if="exportState.modal"
      :title="$t('member.tab.classTicket.exportTitle')"
      :inProgress="exportState.exportting"
      :isError="exportState.error"
      :content="exportState.content"
      :percentage="totalPercentege"
      @close="onExportClose"
    />

    <ClassTicketAdvanceSelect
      v-if="dialog.classTicketAdvanceSelect"
      :data="classTicketOptions"
      :selectedData="compact([classTicketForm.classTicket])"
      disabledExp
      @close="dialog.classTicketAdvanceSelect = false; fetchClassTicketOptions()"
      @confirm="onClassTicketConfirm"
      @filter="handleClassTicketFilter"
    />
  </div>
</template>

<script>
/* eslint-disable vue/no-computed-properties-in-data */
import EmptyBlock from '@/components/EmptyBlock.vue'
import ClassTicketAdvanceSelect from '@/components/Select/ClassTicketAdvanceSelect.vue'
import DeleteDialog from '@/components/Dialog/DeleteDialog'
import ClassTicketRecordDetail from '@/views/ClassTicket/components/ClassTicketRecordDetail.vue'
import {
  GetClassTicket,
  CreateClassTicketRecord,
  GetClassTicketRecord,
  GetClassTicketRecordCount,
  GetClassTicketUseRecord,
  GetClassTicketUseRecordCount,
  CancelClassTicketRecord,
  GetClassTicketRecordSerial,
  GetClassTicketRecordSerialDetail,
  GetClassTicketRecordSerialCount,
  GetClassTicketRecordSerialOld,
} from '@/api/classTicket'
import EditMemberClassTicketRecordModal from './components/EditMemberClassTicketRecordModal.vue'
import LinkItem from '@/components/LinkItem.vue'
import debounce from 'lodash.debounce'
import formUtils from '@/utils/form'
import { pageStartIndex } from '@/utils/table'
import { noEmptyRules, isDigitRules, rangeRules } from '@/validation/index'
import ExportOptionsDialog from '@/components/Dialog/ExportOptionsDialog.vue'
import ExportDialog from '@/components/Dialog/ExportDialog.vue'
import MixinFunc from '@/components/MixinFunc.vue'
import { checkUserFeature } from '@/store/modules/permission'
import { mapGetters } from 'vuex'
import { get, map, join, find, first, compact } from 'lodash'
import {
  classTicketRecordOriginConfig,
  classTicketUseRecordOriginConfig,
  classTicketUseRecordTypeConfig,
} from '@/config/classTicket'

import { getAllDataFromApi } from '@/utils/helper'
import { ExportMoreSheetExcel } from '@/utils/excel'
import { formatDate } from '@/utils/date'
import { t } from '@/plugins/i18n/i18n'

import { useExport } from '@/use/export'
import { useShop } from '@/use/shop'
import { reactive, computed, ref } from 'vue'
import dayjs from '@/lib/dayjs'
import { useClassTicket } from '@/use/classTicket'
import { usePermissions } from '@/use/permissions'
import { useOrgBenefitControl } from '@/use/useOrgBenefitControl'

export default {
  name: 'ClassTicketTab',
  components: {
    ClassTicketAdvanceSelect,
    DeleteDialog,
    EmptyBlock,
    ExportOptionsDialog,
    ExportDialog,
    EditMemberClassTicketRecordModal,
    ClassTicketRecordDetail,
    LinkItem,
  },
  mixins: [MixinFunc],
  props: ['member'],
  setup (props) {
    const { checkActionList, checkAction } = usePermissions()
    const useEditClassTicketRecord = computed(() => checkActionList(['admin.classTicketRecord.use', 'admin.classTicketRecord.useCancel'], 'or'))
    const useEditClassTicketRecordCancel = computed(() => checkAction('admin.classTicketRecord.cancel'))
    const {
      exportState,
      resetExport,
      getExportDataOld,
      totalDataCount,
      totalPercentege,
      curTotalDataCount,
    } = useExport()
    const { classTicketStatusLabel } = useClassTicket()
    const { shopId } = useShop()
    const { isClassTicketBenefitSharingEnabled } = useOrgBenefitControl()
    const classTicketOptions = ref([])
    const dialog = reactive({
      export: false,
      classTicketAdvanceSelect: false,
    })

    const fetchClassTicketOptions = async () => {
      const [res, err] = await GetClassTicket({ shopId: shopId.value })
      if (!err) classTicketOptions.value = res
    }

    const handleClassTicketFilter = async (filters) => {
      const [res, err] = await GetClassTicket({ shopId: shopId.value, ...filters })
      if (!err) classTicketOptions.value = res
    }

    const mapOrigin = (key) => {
      return get(classTicketRecordOriginConfig, `${key}.label`, '-')
    }
    const onExportClose = () => {
      resetExport()
    }
    const formatAddRecordData = (item) => {
      return {
        [t('member.tab.classTicket.exportCode')]: item.code,
        [t('member.tab.classTicket.exportName')]: get(item, 'Member.UserInfo.name') || t('member.tab.classTicket.nonMember'),
        [t('member.tab.classTicket.exportClassName')]: item.name,
        [t('member.tab.classTicket.exportStatus')]: classTicketStatusLabel(item),
        [t('member.tab.classTicket.exportAvailable')]: item.availableTimes,
        [t('member.tab.classTicket.exportUsed')]: item.usedTimes,
        [t('member.tab.classTicket.exportGiven')]: item.giveTimes,
        [t('member.tab.classTicket.exportPrice')]: item.price,
        [t('member.tab.classTicket.exportOrigin')]: mapOrigin(item.origin),
        [t('member.tab.classTicket.exportValidity')]: item.isExp ? t('member.tab.classTicket.yes') : t('member.tab.classTicket.no'),
        [t('member.tab.classTicket.exportExpDate')]: item.exp ? formatDate(item.exp) : '-',
        [t('member.tab.classTicket.exportNote')]: item.note,
        [t('member.tab.classTicket.exportIssueStore')]: get(item, 'Shop.name') || '-',
        [t('member.tab.classTicket.exportGrantStore')]: get(item, 'GrantedShop.name') || '-',
        [t('member.tab.classTicket.exportVerifyStore')]: get(item, 'Branch.name') || '-',
        [t('member.tab.classTicket.exportCreatedAt')]: formatDate(item.createdAt),
      }
    }
    const formatAddRecordSerialData = (item) => {
      return {
        [t('member.tab.classTicket.exportSerialCode')]: get(item, 'code'),
        [t('member.tab.classTicket.exportSerialStatus')]: classTicketStatusLabel(item),
        [t('member.tab.classTicket.exportMemberName')]: get(item, 'ClassTicketRecord.Member.UserInfo.name') || t('member.tab.classTicket.nonMember'),
        [t('member.tab.classTicket.exportCode')]: get(item, 'ClassTicketRecord.code'),
        [t('member.tab.classTicket.exportClassName')]: get(item, 'ClassTicketRecord.name'),
        [t('member.tab.classTicket.exportStatus')]: classTicketStatusLabel(get(item, 'ClassTicketRecord')),
        [t('member.tab.classTicket.exportValidity')]: get(item, 'ClassTicketRecord.isExp') ? t('member.tab.classTicket.yes') : t('member.tab.classTicket.no'),
        [t('member.tab.classTicket.exportExpDate')]: get(item, 'ClassTicketRecord.exp')
          ? formatDate(get(item, 'ClassTicketRecord.exp'))
          : '-',
        [t('member.tab.classTicket.exportOrigin')]: mapOrigin(get(item, 'ClassTicketRecord.origin')),
        [t('member.tab.classTicket.exportFulfilled')]: get(item, 'TicketPaymentPromise.ticketPromiseRecordId') ? t('member.tab.classTicket.yes') : t('member.tab.classTicket.no'),
        // 是否已送履約核銷: '-',
        [t('member.tab.classTicket.exportCreatedAt')]: formatDate(item.createdAt),
      }
    }
    const formatUseRecordData = (item) => {
      return {
        [t('member.tab.classTicket.exportUseTime')]: formatDate(item.createdAt),
        [t('member.tab.classTicket.exportClassName')]: get(item, 'ClassTicketRecord.name'),
        [t('member.tab.classTicket.exportCode')]: get(item, 'ClassTicketRecord.code'),
        [t('member.tab.classTicket.exportUseOrigin')]: get(classTicketUseRecordOriginConfig, `${item.origin}.label`),
        [t('member.tab.classTicket.exportUseStore')]: get(item, 'Branch.name'),
        [t('member.tab.classTicket.exportMemberName')]: get(item, 'ClassTicketRecord.Member.UserInfo.name') || t('member.tab.classTicket.nonMember'),
        [t('member.tab.classTicket.exportUseType')]: get(classTicketUseRecordTypeConfig, `${item.type}.label`),
        [t('member.tab.classTicket.exportUseCancel')]: item.isCancelType ? t('member.tab.classTicket.cancel') : t('member.tab.classTicket.use'),
        [t('member.tab.classTicket.exportUseCancelCount')]: Math.abs(item.times),
        [t('member.tab.classTicket.exportSerialArray')]: join(map(item.ClassTicketRecordSerials, 'code'), ','),
      }
    }
    const prepareExport = async ({ range }) => {
      dialog.export = false
      const payload = {
        shopId: shopId.value,
        MemberId: props.member.id,
        createdAtStart: get(range, '[0]') ? dayjs(get(range, '[0]')).toDate() : undefined,
        createdAtEnd: get(range, '[0]') ? dayjs(get(range, '[1]')).toDate() : undefined,
      }
      exportState.modal = true
      exportState.exportting = true
      try {
        const res = await Promise.all([
          GetClassTicketRecordCount(payload),
          GetClassTicketUseRecordCount(payload),
          GetClassTicketRecordSerialCount(payload, { oldInstance: true }),
        ])
        exportState.dataCount = res
        if (!totalDataCount.value) {
          exportState.content = '尚無資料可匯出'
          exportState.error = true
          window.$message.warning('尚無資料可匯出')
          return
        }

        const [recordData, useRecordData, serialData] = await Promise.all([
          getExportDataOld({ stage: 0, fetchAPI: GetClassTicketRecord, payload }),
          getExportDataOld({ stage: 1, fetchAPI: GetClassTicketUseRecord, payload }),
          getExportDataOld({ stage: 2, fetchAPI: GetClassTicketRecordSerialOld, payload }),
        ])

        const exportData = {
          recordData: [],
          useRecordData: [],
          serialData: [],
        }

        for (const subitem of serialData) {
          const row = formatAddRecordSerialData(subitem)
          exportData.serialData.push(row)
        }
        for (const item of recordData) {
          exportData.recordData.push(formatAddRecordData(item))
        }
        for (const item of useRecordData) {
          exportData.useRecordData.push(formatUseRecordData(item))
        }
        const sheets = [
          {
            sheetName: '堂票新增紀錄',
            data: exportData.recordData,
          },
          {
            sheetName: '堂票序號新增紀錄',
            data: exportData.serialData,
          },
          {
            sheetName: '堂票使用紀錄',
            data: exportData.useRecordData,
          },
        ]
        exportState.success = true
        exportState.content = '匯出完成'
        ExportMoreSheetExcel(sheets, '堂票新增紀錄')
      } catch (error) {
        exportState.exportting = false
        exportState.error = true
      }
    }
    return {
      ExportMoreSheetExcel,
      prepareExport,
      onExportClose,
      totalPercentege,
      totalDataCount,
      curTotalDataCount,
      classTicketStatusLabel,
      mapOrigin,
      exportState,
      dialog,
      get,
      compact,
      first,
      useEditClassTicketRecord,
      useEditClassTicketRecordCancel,
      isClassTicketBenefitSharingEnabled,
      classTicketOptions,
      fetchClassTicketOptions,
      handleClassTicketFilter,
    }
  },
  data () {
    return {
      loading: false,
      classTicketRecordCount: 0,
      classTicketRecordList: [],
      classTicketUseList: [],
      classTicketRecordTableOptions: {
        page: 1,
        pageLimit: 10,
      },

      selectRow: null,
      classTicketForm: {
        classTicket: null,
        price: '',
        note: '',
        times: 1,
        cancel: '',
        name: '',
        quantity: 1,
        status: '',
        availableUseTimes: 0,
        availableTimes: 0,
        usedTimes: 0,
      },

      classTicketFormRules: {
        classTicket: [noEmptyRules()],
        price: [isDigitRules(), noEmptyRules(), rangeRules()],
        quantity: [noEmptyRules(), rangeRules(1)],
        times: [isDigitRules(), noEmptyRules(), rangeRules(1, this.availableTimes)],
        cancel: [isDigitRules(), noEmptyRules(), rangeRules(1, this.usedTimes)],
      },

      classTicketDialog: false,
      classTicketRecordDialog: false,
      deleteDialog: false,

      search: {
        code: '',
      },

      warning: {
        type: null,
        error: null,
        total: 0,
        success: 0,
        fail: 0,
      },
      processing: {
        task: null,
        detail: null,
        title: '',
        inProgress: false,
        isError: false,
        percentage: 0,
      },
      showAll: false,
      btnLoading: {
        use: false,
        cancel: false,
      },
      showDrawer: false,
      classTicketRecordSerials: {},
    }
  },
  computed: {
    ...mapGetters(['userPlanFeature', 'userFeatures']),
    shop () {
      return this.$store.getters.shop
    },

    classTicketRecordStartIndex () {
      return pageStartIndex(
        this.classTicketRecordTableOptions.page,
        this.classTicketRecordTableOptions.pageLimit,
      )
    },

    useClassTicketFeature () {
      return checkUserFeature(this.userPlanFeature, this.userFeatures, 'admin.classTicketRecord.page')
    },

    useStorePermission () {
      return checkUserFeature(this.userPlanFeature, this.userFeatures, 'admin.branch.adminUseStore')
    },

    useTicketPermission () {
      return checkUserFeature(
        this.userPlanFeature,
        this.userFeatures,
        'admin.classTicketConfig.clientGive',
      )
    },

    availableTimes () {
      if (!this.selectRow) return 0
      const available = this.selectRow.availableTimes
      const used = this.selectRow.usedTimes
      return available - used
    },
    usedTimes () {
      if (!this.selectRow) return 0
      const used = this.selectRow.usedTimes
      return used
    },

    selectedClassTicket () {
      if (!this.classTicketForm.classTicket) return []
      const item = find(this.classTicketOptions, { id: this.classTicketForm.classTicket })
      return item ? [item] : []
    },
  },
  async mounted () {
    await this.refresh()
  },
  methods: {
    async refresh (search = false) {
      if (search) this.classTicketRecordTableOptions.page = 1
      this.loading = true
      await this.getClassTicketRecord()
      await this.getClassTicketRecordCount()

      if (get(this.selectRow, 'id')) {
        this.selectRow = find(this.classTicketRecordList, { id: get(this.selectRow, 'id') })
      }

      this.loading = false
    },
    openClassTicketAdvanceSelect (visible) {
      if (visible) {
        this.fetchClassTicketOptions()
        this.dialog.classTicketAdvanceSelect = true
      }
    },
    onClassTicketConfirm (selectedIds) {
      this.classTicketForm.classTicket = first(selectedIds)
      this.dialog.classTicketAdvanceSelect = false
    },
    resetClassTicketForm () {
      formUtils.resetForm(this.$refs.classTicketForm)
      this.classTicketForm = {
        classTicket: null,
        price: '',
        note: '',
        times: 1,
        name: '',
      }
    },

    classTicketOptionLabel (item) {
      const parts = [item.name]
      if (item.Shop?.name) parts.push(`發行店：${item.Shop.name}`)
      if (item.expNotifyDay != null) parts.push(`到期提醒：${item.expNotifyDay}天`)
      return parts.join(' | ')
    },

    resetForm (form) {
      formUtils.resetForm(this.$refs[form])
    },

    classTicketTagType (val) {
      let type = 'info'
      if (val === 'open') type = 'action'
      if (val === 'cancel') type = 'danger'
      if (val === 'overdue') type = 'warning'
      return type
    },

    classTicketIsExpTag (val) {
      let type = 'info'
      // if(! val) type = 'danger'
      if (val) type = 'warning'
      return type
    },

    //= > 取得堂票紀錄
    async getClassTicketRecord () {
      try {
        const res = await GetClassTicketRecord({
          shopId: this.shop,
          start: this.classTicketRecordStartIndex,
          limit: this.classTicketRecordTableOptions.pageLimit,
          code: this.search.code === '' ? undefined : this.search.code,
          MemberId: this.member.id,
        })

        this.classTicketRecordList = res
      } catch (error) {
        console.log(error)
        this.$message.error({
          message: error || error.message,
        })
      }
    },

    //= > 取得堂票紀錄總數
    async getClassTicketRecordCount () {
      try {
        this.classTicketRecordCount = await GetClassTicketRecordCount({
          shopId: this.shop,
          code: this.search.code === '' ? undefined : this.search.code,
          MemberId: this.member.id,
        })
      } catch (error) {
        console.log(error)
        this.$message.error({
          message: error || error.message,
        })
      }
    },

    deBounce: debounce(
      async function () {
        try {
          if (!(await formUtils.checkForm(this.$refs.classTicketForm))) {
            return
          }
          await CreateClassTicketRecord({
            shopId: this.shop,
            memberId: this.member.id,
            classTicketId: this.classTicketForm.classTicket,
            price: this.classTicketForm.price,
            quantity: this.classTicketForm.quantity,
            note: this.classTicketForm.note === '' ? undefined : this.classTicketForm.note,
          })
          this.$message.success('新增堂票成功')
          await this.refresh()
          this.classTicketDialog = false
          this.resetClassTicketForm()
        } catch (error) {
          console.log(error)
          this.$message.error({
            message: error || error.message,
          })
        }
        this.classTicketDialog = false
      },
      300,
      { leading: true, trailing: false },
    ),

    //= > 作廢堂票紀錄
    async cancelClassTicketRecord () {
      try {
        await CancelClassTicketRecord({
          shopId: this.shop,
          id: this.selectRow.id,
        })

        await this.getClassTicketRecord()
        this.deleteDialog = false
        this.showDrawer = false
        this.$message.success('取消成功')
      } catch (error) {
        console.log(error)
        this.$message.error({
          message: error || error.message,
        })
      }
    },
    //= > 查找堂票
    async findClassTicket (row) {
      this.selectRow = row
      this.getClassTicketSerial()
      this.showDrawer = true
    },
    async getClassTicketSerial () {
      const [res, err] = await GetClassTicketRecordSerialDetail({
        shopId: this.shop,
        id: this.selectRow.id,
      })
      if (err) window.$message.error(err)
      this.classTicketRecordSerials = res
    },
    // ----------- Export -----------
    async getExportData (type) {
      let fetchApi = GetClassTicketRecord
      if (type === 'use') fetchApi = GetClassTicketUseRecord
      const payload = {
        shopId: this.shop,
        start: 0,
        limit: 100,
        search: this.search.all || undefined,
        MemberId: this.member.id || undefined,
      }

      return await getAllDataFromApi(this.exportTotal, fetchApi, payload)
    },
    resetProcessing () {
      this.processing.task = null
      this.processing.title = ''
      this.processing.percentage = 0
      this.processing.isError = false
      this.processing.inProgress = false
    },
    // async prepareExport ({ all, range }) {
    //   console.log('all', all)
    //   console.log('range', range)
    //   this.dialog.export = false
    //   this.resetExport()
    //   // 取得匯出數據數量

    //   const res = await GetClassTicketRecordCount({
    //     shopId: this.shop,
    //     search: this.search.all || undefined,
    //     MemberId: this.member.id || undefined,
    //   })
    //   this.exportTotal = res
    //   if (!this.exportTotal) {
    //     this.$message.warning('沒有資料可以匯出')
    //     return
    //   }
    //   this.showExportDialog = true
    //   this.exportting = true
    //   try {
    //     const addData = await this.getExportData('add')
    //     this.exportData = addData
    //     const useData = await this.getExportData('use')
    //     this.exportUseData = useData
    //     await this.formatExportData()
    //     this.exportting = false
    //   } catch (error) {
    //     console.log(error)
    //     this.exportting = false
    //     this.exportError = true
    //     this.$message.error(error)
    //   }
    // },
    async recordSerial () {
      const [res, err] = await GetClassTicketRecordSerial({
        shopId: this.shop,
        start: 0,
        limit: 100,
        MemberId: this.member.id || undefined,
      })
      if (err) this.$message.error(err)
      return res
    },
    closeDrawer () {
      this.showDrawer = false
      this.selectRow = null
      this.classTicketRecordSerials = {}
    },
  },
}
</script>

<style scoped lang="scss">
.use-history-container {
  @apply grid grid-flow-row gap-[8px];
}
</style>
